// src/pages/Contact/Contact.js
import React from 'react';
import './Contact.css';
import {
  FaGithub,
  FaLinkedin,
  FaEnvelope
} from 'react-icons/fa';

function Contact() {
  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Contact Me</h1>
        <p>Feel free to reach out through any of the following channels.</p>
      </div>

      <div className="contact-container">
        <div className="contact-section">
          <div className="contact-card">
            <div className="contact-icon">
              <FaGithub />
            </div>
            <div className="contact-info">
              <h3>GitHub</h3>
              <p>Check out my code repositories and projects</p>
              <a
                href="https://github.com/CarlGathmann"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                github.com/CarlGathmann
              </a>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaLinkedin />
            </div>
            <div className="contact-info">
              <h3>LinkedIn</h3>
              <p>Connect with me professionally</p>
              <a
                href="https://www.linkedin.com/in/carl-gathmann-34084b23a/"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                linkedin.com/in/carl-gathmann-34084b23a
              </a>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <FaEnvelope />
            </div>
            <div className="contact-info">
              <h3>Email</h3>
              <p>Send me a message directly</p>
              <a
                href="mailto:work@cgathmann.de"
                className="contact-link"
              >
                work@cgathmann.de
              </a>
            </div>
          </div>
        </div>

        <div className="contact-message">
          <h2>Let's Work Together</h2>
          <p>
            I'm currently available for freelance projects, research collaboration,
            and full-time positions in robotics and autonomous systems engineering.
          </p>
          <p>
            Whether you have a specific project in mind or just want to connect,
            I'd be happy to hear from you!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;